'use strict';

const APPLICATION_MODULE_NAME = 'lmrcApp';

// see client/polyfills.js for jQuery and es* polyfills
require('jquery-file-download');

import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';

// application Store (with Redux)
// if (process.env.NODE_ENV != 'production') { store = require('./store.config.dev').default; }
import store from './store.config';

// angular-ui modules
import uiRouter from '@uirouter/angularjs';
import uiBootstrap from 'angular-ui-bootstrap';
import 'ui-select';

// additional 3rd party modules
import 'angular-translate';
const translateModule = 'pascalprecht.translate';
require('../../node_modules/angular-pdfjs-viewer/dist/angular-pdfjs-viewer');


// current specific application modules
import productConfig from './app.config/index';

import insertEmail from './features/insert-email';
import disclosure from './features/disclosure';
import pecImport from './features/pec-import';
import contactInfo from './features/contact-info';
import changePassword from './features/change-password';
import success from './features/success';

import mainLayout from './layout/main-layout';
import externalLayout from './layout/external-layout';

import constants from './app.constants';
import util from '../components/util/util.module';

// InfoCert fe libraries
import feconClientBundle from '@infocert/fecon-client-bundle';
import feconIsac from '@infocert/fecon-isac';
import isacIntegration from './isac-integration'; // fecon-isac integration

import pecImportContainer from '../components/pec-import-container/pec-import.module';
// Style root
import './app.scss';


import apiService from '../components/api-service';


angular.module(APPLICATION_MODULE_NAME, [
    // angular official modules
    ngAnimate, ngCookies, ngResource, ngSanitize, ngMessages,

    // angular-ui modules
    uiRouter, uiBootstrap,

    // additional 3rd party modules
    translateModule,
    'pdfjsViewer',
    // application Store (with redux)
    store,
    apiService,

    // InfoCert FeCon common spa modules
    feconClientBundle,
    feconIsac,

    // current specific application modules
    isacIntegration, // fecon-isac integration
    productConfig,

    mainLayout,
    constants,
    util,
    externalLayout,
    insertEmail,
    disclosure,
    pecImport,
    pecImportContainer,
    contactInfo,
    changePassword,
    success
]);


angular.element(document)
    .ready(() => {
        angular.bootstrap(document, [APPLICATION_MODULE_NAME], {
            strictDi: true
        });
    });


// WEBPACK FOOTER //
// ./client/app/app.js